import React from 'react';
import { BottomSheetBackdrop, BottomSheetBackdropProps } from '@gorhom/bottom-sheet';

/**
 * Standard backdrop for every BottomSheetModal (see CLAUDE.md sheet rules):
 * fades out at -1, in at 0. Module-scope components are referentially
 * stable, so pass directly: `backdropComponent={SheetBackdrop}` — no
 * per-sheet useCallback needed.
 */
export function SheetBackdrop(props: BottomSheetBackdropProps) {
  return <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} opacity={0.5} />;
}

/** Lighter dim used by the quick menu-style sheets (create menu, tour, roles). */
export function SheetBackdropLight(props: BottomSheetBackdropProps) {
  return <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} opacity={0.4} />;
}
